<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-l">
		<wa-button [routerLink]="['/frameworks/bootstrap']" appearance="plain" variant="neutral">&larr; Back to Bootstrap</wa-button>
		<div class="wa-cluster" style="align-items:center;justify-content:space-between;">
			<h1 waHeading="xl" waText>BSCheckBox</h1>
			<a href="javascript:void(0)" onclick="document.getElementById('examples-section')?.scrollIntoView({behavior:'smooth'})" style="color:var(--wa-color-brand-normal);cursor:pointer;font-size:var(--wa-font-size-s);white-space:nowrap;">Examples ↓</a>
		</div>
		<p waBody="m" waColorText="quiet" waText>Styled checkbox inputs with contextual colour variants. Pre-styled variants include BSCheckBoxPrimary, BSCheckBoxDanger, BSCheckBoxSuccess, etc.</p>
		<wa-details appearance="outlined" summary="Import, Interfaces & Constructors">
			<div class="wa-stack wa-gap-m">
				<div waCaption="s" waFontWeight="semibold" waText>IMPORT</div>
				<markdown [data]="mdContent_86" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				<div waCaption="s" waFontWeight="semibold" waText>CONSTRUCTORS</div>
				<markdown [data]="mdContent_87" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				<p waBody="s" waColorText="quiet" waText>Creates a styled checkbox</p>
			</div>
		</wa-details>
		<div class="wa-stack wa-gap-m" id="examples-section">
			<h2 waHeading="l" waText>Examples</h2>
			<div class="wa-stack wa-gap-xs">
				<h4 waHeading="s" waText>Checkbox Group</h4>
				<p waBody="s" waColorText="quiet" waText>Create a group of styled checkboxes.</p>
				<markdown [data]="mdContent_88" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
			</div>
		</div>
	</div>
</div>